export enum MaritalStatusEnumDto {
    Single = "single",
    Married = "married",
    CommonLaw = "common_law",
    Separated = "separated",
    Divorced = "divorced",
    Widowed = "widowed",
}
